import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Navbar from '../../components/navbar';
import isLoggedIn from '../../utils/isLoggedIn';
import SupplierRFQSentTable from '../../components/quantila/supplier_rfq_sent_table';
import { convertEntitiesDeep } from '../../utils/convertEntities';

const SupplierQueries = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = sessionStorage.getItem('token');
  const [supplierName, setSupplierName] = useState();
  const [queries, setQueries] = useState([]);

  useEffect(() => {
    isLoggedIn(navigate, dispatch, `/quantila/supplier/queries/${id}`);
    let active = true;

    (async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/admin/quantila/supplier/${id}/queries`,
        { headers: { authorization: `Bearer ${token}` } },
      );
      if (active) {
        const data = convertEntitiesDeep(response.data);
        setSupplierName(data.name);
        setQueries(data.queries || []);
      }
    })();

    return () => {
      active = false;
    };
  }, [id]);

  return !supplierName ? (
    <div className='loading'>
      <img src='/img/loading.gif' alt='Loading' className='loading-img' />
    </div>
  ) : (
    <>
      <Helmet>
        <title>{`Badgers SAS: Queries for ${supplierName}`}</title>
        <meta name='page' content='quantila supplier queries' />
      </Helmet>
      <Navbar displayMob={true} />
      <div className='container'>
        <div>
          <Link className='page-links' to='/'>
            <FontAwesomeIcon icon='home' />{' '}
          </Link>
          <Link className='page-links' to={`/quantila/supplier/${id}`}>
            {supplierName}
          </Link>{' '}
          <span className='link-span'>
            <FontAwesomeIcon icon='angle-right' />
          </span>
          <span className='link-span'>SUPPLIER QUERIES</span>
        </div>
        <div className='col-12 d-flex justify-content-center my-4'>
          <h4 className='h4'>
            {`RFQ QUERIES TO: ${supplierName}`}{' '}
            <FontAwesomeIcon icon='paper-plane' />
          </h4>
        </div>
        <SupplierRFQSentTable sentQueries={queries} />
      </div>
    </>
  );
};

export default SupplierQueries;
